
import axios from 'axios';
import store from '@/store';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URI,
});

const getMoedaId = (currentLanguage) => {
  const isLoggedIn = store.state.auth?.user;
  const estrangeiro = store.state.auth?.user?.estrangeiro;

  if (isLoggedIn) {
    return estrangeiro === true ? 2 : 3;
  }

  switch (currentLanguage) {
    case 'es-PY':
      return 3;
    case 'pt-BR':
      return 2;
    default:
      return 2;
  }
};

const getCurrencySymbol = (moedaId) => {
  switch (moedaId) {
    case 3:
      return 'G$';
    case 2:
      return 'U$';
    default:
      return '';
  }
};

export const formatPrice = (price, moedaId) => {
  const symbol = getCurrencySymbol(moedaId);

  if (moedaId === 3) {
    return `${symbol} ${price.toLocaleString('es-PY', {
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`;
  }

  return `${symbol} ${price.toLocaleString('pt-BR', {
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

api.interceptors.request.use((config) => {
  const currentLanguage = store.state.language.currentLanguage || 'pt-BR';
  const moedaId = getMoedaId(currentLanguage);
  config.params = { ...config.params, moeda_id: moedaId };
  return config;
});

export const fetchProducts = async (otherParams = {}) => {
  store.dispatch('general/setLoading', true);
  try {
    const moedaId = otherParams.moeda_id || getMoedaId(store.state.language.currentLanguage);
    //store.commit('setMoedaId', moedaId);

    const response = await api.get('api/public/products', { params: { ...otherParams, moeda_id: moedaId } });
    const productData = response.data;

   productData.data.forEach(product => {
  if (product.valor_venda && product.moeda) {
    const price = parseFloat(product.valor_venda);
    const moedaId = product.moeda.id;
    product.formattedPrice = formatPrice(price, moedaId); // ✅ Adiciona o campo esperado
  }
});


    return productData;
  } catch (error) {
    console.error('Erro ao buscar produtos:', error);
    throw error;
  } finally {
    store.dispatch('general/setLoading', false);
  }
};

export const fetchProductDetails = async (slug) => {
  store.dispatch('general/setLoading', true);
  try {
    const currentLanguage = store.state.language.currentLanguage || 'pt-BR';
    const langParam = currentLanguage === 'es-PY' ? 'es' : '';
    const url = `api/public/products/${slug}/details`;

    const response = await api.get(url, { params: { lang: langParam } });
    const productData = response.data;

    if (productData.preco_atual && productData.moeda) {
      const price = parseFloat(productData.preco_atual.valor_venda);
      const moedaId = getMoedaId(currentLanguage);
      productData.preco_atual.formatado = formatPrice(price, moedaId);
    }

    productData.token = productData.token || '';
    return productData;
  } catch (error) {
    console.error('Erro ao buscar detalhes do produto:', error);
    throw error;
  } finally {
    store.dispatch('general/setLoading', false);
  }
};


export const getPriceWithCurrency = (price) => {
  const moedaId = store.state.moedaId || getMoedaId(store.state.language.currentLanguage);
  return formatPrice(price, moedaId);
};

export const fetchProductsByBrandId = async (brandId, otherParams = {}) => {
  store.dispatch('general/setLoading', true);
  try {
    const response = await api.get('api/public/products', {
      params: { brand_id: brandId, ...otherParams },
    });
    const moedaId = otherParams.moeda_id || getMoedaId(store.state.language.currentLanguage);
    // store.commit('setMoedaId', moedaId);

    response.data.data.forEach(product => {
      product.token = product.token || '';
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produtos da marca:', error);
    throw error;
  } finally {
    store.dispatch('general/setLoading', false);
  }
};


export const fetchCategories = async (params = {}) => {
  store.dispatch('general/setLoading', true);
  try {
    const currentLanguage = store.state.language.currentLanguage || 'pt-BR';
    const langParam = currentLanguage === 'es-PY' ? '?lang=es' : '';

    const finalParams = { ...params, special: 'only' };

    const response = await api.get(`api/public/categories${langParam}`, { params: finalParams });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar categorias:', error);
    throw error;
  } finally {
    store.dispatch('general/setLoading', false);
  }
};

export const fetchBrands = async () => {
  store.dispatch('general/setLoading', true);
  try {
    const response = await api.get('api/public/brands');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar marcas:', error);
    throw error;
  } finally {
    store.dispatch('general/setLoading', false);
  }
};

export const calculateShipping = async (
  cart,
  selectedCity,
  selectedStateName,
  user,
  cep,
  additionalParams = {}
) => {
  try {
    if (!selectedCity || !cart || cart.itens.length === 0) {
      throw new Error("Selecione uma cidade e tenha itens no carrinho!");
    }

    if (!cart.external_id) {
      throw new Error("External ID não disponível no carrinho.");
    }

    let payload = {
      cidade_id: selectedCity,
      id: cart.id,
      external_id: cart.external_id,
      filial_id: 1,
      moeda_id: cart.moeda_id,
      cep: cep,
      itens: cart.itens.map((item) => ({
        produto_id: item.produto_id,
        armazem_id: 1,
        valor_unitario: item.valor_unitario,
        qtde: item.qtde,
        ativo: true,
      })),
      ...(additionalParams.cidade_alternativa_id && {
        cidade_alternativa_id: additionalParams.cidade_alternativa_id
      }),
      ...(additionalParams.id_servico && {
        id_servico: additionalParams.id_servico
      }),
      ...(additionalParams.id_ponto_entrega && {
        id_ponto_entrega: additionalParams.id_ponto_entrega
      }),
      ...(additionalParams.cliente_endereco_id && {
        cliente_endereco_id: additionalParams.cliente_endereco_id
      })
    };

    if (user && user.enderecos && user.enderecos.length > 0) {
      const userCountryId = user.enderecos[0].pais_id;
      const userCep = user.enderecos[0].cep;

      payload.pais_id = userCountryId;
      if (userCep) {
        payload.cep = userCep;
      }
    } else {
      payload.pais_id = 2;
    }

    const url = `${process.env.VUE_APP_API_URI}/ecom/venda/carrinho/${cart.external_id}/calcular-frete`;
    const token = store.state.auth?.token || localStorage.getItem("authToken");
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

    const response = await api.put(url, payload, config);
    const deliveryOptions = response.data;

    const shippingCost = deliveryOptions.length > 0 ? deliveryOptions[0].valor : 0;

    return { shippingCost, deliveryOptions };
  } catch (error) {
    console.error("Erro ao calcular frete:", error.response?.data || error.message || error);
    throw new Error("Erro ao calcular o frete. Detalhes: " + (error.response?.data || error.message || error));
  }
};


export const fetchPickupPoints = async (cartId) => {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_URI}/ecom/venda/carrinho/${cartId}/pontos-entrega`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar pontos de entrega:", error);
    throw new Error("Erro ao buscar pontos de entrega. Detalhes: " + (error.response?.data || error.message));
  }
};

export const fetchCategoriesByBrandId = async (brandId) => {
  try {
    const response = await api.get('/api/public/categories', {
      params: { brand_id: brandId }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar categorias por marca:', error);
    throw error;
  }
};

export const fetchVehicleBrands = async () => {
  const response = await api.get('/api/public/vehicle-brands');
  return response.data;
};

export const fetchVehicleModels = async (brandId) => {
  const response = await api.get('/api/public/vehicles', {
    params: { veiculo_marca_id: brandId }
  });
  return response.data.data;
};

export const fetchVehicleYears = async (brandId, modelId) => {
  const response = await api.get('/api/public/vehicles', {
    params: {
      veiculo_marca_id: brandId,
      veiculo_modelo_id: modelId
    }
  });
  return response.data.data;
};
export const fetchFaqs = async () => {
  const response = await api.get('/api/public/faq');
  return response.data;
};
export const fetchExchangeRates = async () => {
  const response = await api.get('/api/public/exchange-rates');
  return response.data;
};
export const fetchTeam = async () => {
  const response = await api.get('/api/public/team');
  return response.data;
};
export const fetchBrandsByCategory = async (categorySlug) => {
  try {
    const response = await api.get(`/api/public/categories/${categorySlug}`);
    const { brands = [] } = response.data;

    return brands
      .map(brand => ({
        id: brand.id,
        name: brand.nome,
        slug: brand.slug
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  } catch (error) {
    console.error('Erro ao buscar marcas por categoria:', error);
    return [];
  }
};


export const fetchBrandsByDepartment = async (departmentSlug) => {
  store.dispatch('general/setLoading', true);
  try {
    const response = await api.get(`/api/public/departments/${departmentSlug}`);
    const { brands = [] } = response.data;

    return brands
      .map(brand => ({
        id: brand.id,
        name: brand.nome,
        slug: brand.slug
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  } catch (error) {
    console.error('Erro ao buscar marcas por departamento:', error);
    return [];
  } finally {
    store.dispatch('general/setLoading', false);
  }
};
export const fetchBrandDetails = async (slug) => {
  try {
    const brands = await fetchBrands(); 
    return brands.find(brand => brand.slug === slug) || null;
  } catch (error) {
    console.error('Erro ao buscar detalhes da marca:', error);
    return null;
  }
};
